export { Testimonials, type TestimonialsProps } from './Testimonials';
